<template>
  <div class="news">
    <div class="row" v-if="arrs.length">
      <router-link
        :to="'/detail/' + item.id"
        v-for="(item, index) in arrs"
        :key="index"
        class="margin-bottom-20 col-md-6"
      >
        <div class="newslist">
          <div class="row">
            <div class="col-md-9">
              <div class="title">{{ item.title }}</div>
              <div class="author">发布者: {{ item.id }}</div>
            </div>
            <div class="col-md-3" v-if="item.updateTime">
              <div class="date">{{ item.updateTime.slice(-2) }}</div>
              <div class="year">
                {{ item.updateTime.slice(0, item.updateTime.length - 3) }}
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div v-else style="text-align: center; width: 100%; padding: 20px">
      <span>暂无资讯</span>
    </div>
    <!-- <div class="text-center margin-bottom-20">
    <div class="page">
      <button class="btn btn-default margin-right-10" :class="{'active':activenum === 0}" type="submit" @click="primaryPage" >首页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="prePage" :class="{'active':activenum === 1}">上页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="nextPage" :class="{'active':activenum === 2}">下页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="lastPage" :class="{'active':activenum === 3}">尾页</button>
      <button class="btn btn-default" type="submit" style="background: none">{{current_page}}/{{Math.ceil(arrs.length/pagesize)}}</button>
    </div>
  </div> -->
  </div>
</template>

<script>
export default {
  name: "NewsList",
  props: {
    arrs: Array,
  },
  data: function () {
    return {
      currentPage: 1, // 当前页号
      activenum: 0, // 每页大小
      pagesize: 5,
    };
  },
  computed: {
    page_arrs() {
      let { currentPage, pagesize } = this;
      return this.arrs.slice(
        (currentPage - 1) * pagesize,
        currentPage * pagesize
      );
    },
    current_page() {
      return this.currentPage;
    },
  },
  methods: {
    primaryPage() {
      this.currentPage = 1;
      this.activenum = 0;
    },
    prePage() {
      if (this.currentPage === 1) {
        this.activenum = 1;
        return;
      }
      this.currentPage = this.currentPage - 1;
      this.activenum = 1;
    },
    nextPage() {
      if (this.currentPage === Math.ceil(this.arrs.length / this.pagesize)) {
        return;
      }
      this.currentPage = this.currentPage + 1;
      this.activenum = 2;
    },
    lastPage() {
      this.currentPage = Math.ceil(this.arrs.length / this.pagesize);
      this.activenum = 3;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.news {
  background: #fff;
  padding: 20px 28px;
  min-height: calc(100vh - 676px);
}

.newslist {
  background: #fbfbfb;
  padding: 20px;
  margin-bottom: 20px;
  height: 120px;

  &:hover {
    box-shadow: 0px 0px 10px #999;
  }

  .title {
    font-size: 16px;
    line-height: 24px;
    height: 48px;
    ellipsis2();
    margin-bottom: 10px;
  }

  .author {
    font-size: 14px;
    color: #999;
  }

  .col-md-9 {
    border-right: 1px dashed #efefef;
  }

  .col-md-3 {
    text-align: center;

    .date {
      font-size: 30px;
      padding-top: 10px;
      margin-bottom: 20px;
    }

    .year {
      color: #999;
    }
  }
}

.btn {
  width: 80px;
  height: 32px;
  line-height: 32px;
  padding: 0;
  background: #cbccce;
  text-align: center;
  color: #fff;
  border: none;
}

.active {
  background: $bgColor;
}

.title {
  color: #333;
}

.date {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/pages/news/components/NewsList.vue